import React from "react";
import PropTypes from "prop-types";
import RespondTo from "./respond-to";
import get from "lodash.get";
import { Loading } from "@evertrue/et-components";
import { PromiseResolverLoading } from "@evertrue/promise-resolver";
import { WithPromises } from "../contexts/api-context";
import ActivityBreakdown from "./activity-breakdown";
import PoolActivityNumbers from "./pool-activity-numbers";
import { formatInteractionStatsByType } from "../utils/utils";

const propTypes = {
  poolId: PropTypes.number,
  prospectsTotal: PropTypes.number,
  assigned: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  activityDateParameters: PropTypes.shape({
    gte: PropTypes.string,
    lte: PropTypes.string,
  }),
  promises: PropTypes.object,
  solicitorUserId: PropTypes.number,
};

const PoolActivityReport = ({
  activityDateParameters,
  poolId,
  prospectsTotal,
  assigned = "all",
  promises,
  solicitorUserId,
  solicitorContactId,
  showBar,
}) => {
  return (
    <div>
      <PromiseResolverLoading
        LoadingComponent={<Loading />}
        args={{ assigned, activityDateParameters }}
        promise={() =>
          promises
            .fetchActivityType({
              poolId,
              assigned,
              activityDateParameters,
              solicitorUserId,
            })
            .then(formatInteractionStatsByType)
        }
        children={({ data: { total: interactionTotalByPool = 0, interactionStatsByType = {} } }) => {
          return (
            <RespondTo className="pool-activity-report">
              <RespondTo className="pool-activity-report--left">
                <ActivityBreakdown
                  showBar={showBar}
                  interactionTotalByPool={interactionTotalByPool}
                  interactionStatsByType={interactionStatsByType}
                />
              </RespondTo>
              <RespondTo className="pool-activity-report--right">
                <PromiseResolverLoading
                  args={{ assigned, activityDateParameters, poolId }}
                  promise={({ assigned, activityDateParameters, poolId }) =>
                    promises.fetchNumberOfProspectsWithInteractions({
                      poolId,
                      assigned,
                      activityDateParameters,
                      solicitorContactId,
                    })
                  }
                  render={({ data: prospectsWithInteractions = {} }) => {
                    return (
                      <PoolActivityNumbers
                        interactionTotalByPool={interactionTotalByPool}
                        prospectsWithInteractions={prospectsWithInteractions.total}
                        prospectsTotal={prospectsTotal}
                      />
                    );
                  }}
                />
              </RespondTo>
            </RespondTo>
          );
        }}
      />
    </div>
  );
};

PoolActivityReport.propTypes = propTypes;

export default WithPromises(PoolActivityReport);
